import { withInstall } from '@antdv/utils';
import AInputNumber from './src/InputNumber';

export const InputNumber = withInstall(AInputNumber);

export default InputNumber;

export * from './src/props';
